import * as React from 'react';
import Modal, {
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter
} from '../../../common/modal';
import classnames from 'classnames';
import { QuestionTypes, IQuestionTypeItem } from '@nexxt/common/questionTypes';
import { QTYPES, QTYPES_CATEGORY, VIEW_MODE } from '@nexxt/common/types';
import {
    AUDIENCE_QTYPE,
    DEV_QTYPES,
    IN_PROGRESS_QTYPES
} from '../../../../constants/question';
import { dataTestid } from '../../../../constants/dataTestid';

export interface IQuestionTypeModalProps {
    isOpen: boolean;
    isAudience: boolean;
    viewMode: string;
    onDone: (questionType: QTYPES) => void;
    onCancel: () => void;
}

export interface IQuestionTypeModalState {
    searchText: string;
    currentTab: 'question-type' | 'question-library';
    selectedQuestionTypes: QTYPES;
}

export default class QuestionTypesModal extends React.Component<
    IQuestionTypeModalProps,
    IQuestionTypeModalState
> {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            currentTab: 'question-type',
            selectedQuestionTypes: null
        };
    }
    changeTab = (tab: string) => {
        // Feature to be implemented when working with question library
    };

    selectQuestionType = (selectedQuestionTypes: QTYPES) => {
        this.setState({
            selectedQuestionTypes
        });
    };

    changeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            searchText: event.target.value
        });
    };

    onDone = () => {
        if (this.state.selectedQuestionTypes) {
            this.props.onDone(this.state.selectedQuestionTypes);
        }
    };

    /**
     * Tabs for question library and question types
     */
    renderTabs = () => {
        const { state } = this;
        return (
            <div className="modal-tabs">
                {/* <div
                    className={classnames('tab-item', {
                        active: state.currentTab === 'question-type'
                    })}
                    onClick={() => this.changeTab('question-type')}
                >
                    Question type
                </div> */}
                {/* <div
                    className={classnames('tab-item', {
                        active: state.currentTab === 'question-library'
                    })}
                    onClick={() => this.changeTab('question-library')}
                >
                    Question library
                </div> */}
            </div>
        );
    };

    filterQuestionTypeBySearchText = (qtype, searchText) => {
        if (
            ![
                QTYPES.MULTIPLE_CHOICE,
                ...(this.props.viewMode === VIEW_MODE.DEV ? [] : DEV_QTYPES)
            ].includes(qtype.value)
        ) {
            return (
                qtype.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1
            );
        }
    };

    renderQuestionTypes = () => {
        const { isAudience, viewMode } = this.props;
        const { searchText, selectedQuestionTypes } = this.state;
        const questionTypes = QuestionTypes;
        const categories = Object.values(QTYPES_CATEGORY);

        const questionTypesNode = categories
            .filter((category) => category !== QTYPES_CATEGORY.BUILT_IN)
            .map((category, index) => {
                const filteredCategory = questionTypes[category].find((types) =>
                    this.filterQuestionTypeBySearchText(types, searchText)
                );

                return (
                    <React.Fragment key={index}>
                        <p className="question-types--list-title">
                            {!searchText.trim()
                                ? category
                                : filteredCategory?.category}
                        </p>
                        <div className="question-types--list list-box">
                            {questionTypes[category as QTYPES_CATEGORY].map(
                                (types, qindex) => {
                                    const isSupportQtype =
                                        (isAudience &&
                                            !AUDIENCE_QTYPE.includes(
                                                types.value as QTYPES
                                            )) ||
                                        IN_PROGRESS_QTYPES.includes(
                                            types.value as QTYPES
                                        );
                                    if (
                                        (viewMode !== VIEW_MODE.DEV &&
                                            DEV_QTYPES.includes(types.value)) ||
                                        types.value === QTYPES.MULTIPLE_CHOICE
                                    ) {
                                        return null;
                                    }
                                    if (
                                        (searchText.trim() &&
                                            !this.filterQuestionTypeBySearchText(
                                                types,
                                                searchText
                                            )) ||
                                        isSupportQtype
                                    ) {
                                        return null;
                                    }
                                    return (
                                        <QuestionTypeItems
                                            key={types.name}
                                            questionType={types}
                                            selectedQuestionTypes={
                                                selectedQuestionTypes
                                            }
                                            selectQuestionType={
                                                this.selectQuestionType
                                            }
                                            disabled={isSupportQtype}
                                        />
                                    );
                                }
                            )}
                        </div>
                    </React.Fragment>
                );
            });

        return (
            <div className="question-types">
                <div className="filters">
                    <div className="filters--search">
                        <input
                            type="text"
                            placeholder="Search question types"
                            value={searchText}
                            onChange={this.changeSearch}
                        />
                        <i className="nx nx-search" />
                    </div>
                </div>
                <div className="question-types--list-container">
                    {questionTypesNode}
                </div>
            </div>
        );
    };

    render() {
        const { props } = this;
        const disabledDone = !this.state.selectedQuestionTypes;
        return (
            <Modal
                isOpen={props.isOpen}
                className={classnames('modal-dialog--question-types')}
            >
                <ModalHeader onClose={props.onCancel}>
                    <ModalTitle>Select questions</ModalTitle>
                    {this.renderTabs()}
                </ModalHeader>
                <ModalBody>{this.renderQuestionTypes()}</ModalBody>
                <ModalFooter>
                    <button
                        className="btn btn--sm btn--transparent m-r-10"
                        onClick={props.onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        className={classnames('btn btn--sm btn--green', {
                            disabled: disabledDone
                        })}
                        onClick={this.onDone}
                        disabled={disabledDone}
                        data-test={dataTestid.QUESTION_MODAL_DONE}
                    >
                        Done
                    </button>
                </ModalFooter>
            </Modal>
        );
    }
}

const QuestionTypeItems: React.SFC<{
    questionType: IQuestionTypeItem;
    selectedQuestionTypes: QTYPES;
    disabled?: boolean;
    selectQuestionType: (questionType: QTYPES) => void;
}> = ({
    questionType,
    selectedQuestionTypes,
    disabled = false,
    selectQuestionType
}) => (
    <div
        className={classnames('list-item', {
            active: !disabled && selectedQuestionTypes === questionType.value,
            selected: !disabled && selectedQuestionTypes === questionType.value,
            disabled: disabled
        })}
        onClick={() => !disabled && selectQuestionType(questionType.value)}
    >
        <div className="list-item--image">
            <img src={questionType.image} alt={questionType.name} />
        </div>
        <div className="list-text">
            <div data-test={questionType.name} className="list-title">
                {questionType.name}
            </div>
        </div>
        {selectedQuestionTypes === questionType.value ? (
            <i className="nx nx-check"></i>
        ) : null}
    </div>
);
